import React from 'react';

import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';
import { useHover } from '~/ui/hooks/interaction';

function ItemPartySigner({ name, onRemove }) {
  const intl = useIntl();
  const [hoverRef, isHovered] = useHover();

  return (
    <FlexLayout
      alignItems="center"
      bg={isHovered ? 'gray-200' : 'gray-300'}
      justifyContent="space-between"
      px={6}
      py={2}
      ref={hoverRef}
      sx={{ borderRadius: 'm', minHeight: '3.5rem' }}
    >
      <Text color="gray-900" variant="m-spaced-bold">
        {name}
      </Text>
      {isHovered && (
        <IconButton
          icon="trash"
          tooltip={intl.formatMessage({
            id: 'ItemPartySigner.removeTooltip',
            defaultMessage: 'remove',
            description: 'Tooltip text for remove button',
          })}
          onClick={onRemove}
        />
      )}
    </FlexLayout>
  );
}

export default ItemPartySigner;
